import ChartInfo from './ChartInfo'

export default ChartInfo
